/**
 * Preco AO VIVO nos cards de produto do blog (.produto-card).
 * Criado 30/07/2026 -- Giovana pediu pra parar de depender do preco
 * ESTATICO escrito no corpo do post ("Precos consultados em DD/MM").
 * Le o preco real na hora via endpoint publico da Shopify
 * /products/<handle>.js (o mesmo que o carrinho usa) e substitui o
 * texto do card. Se o fetch falhar (produto removido, rede etc.),
 * mantem o preco estatico que ja estava escrito -- nunca quebra o card.
 */
(function () {
  function formatBRL(valor) {
    var num = typeof valor === 'string' ? parseFloat(valor) : valor / 100;
    return 'R$ ' + num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function atualizarCard(card) {
    var href = card.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];

    fetch('/products/' + handle + '.js', { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('sem produto'); return r.json(); })
      .then(function (produto) {
        var priceEl = card.querySelector('.produto-card__price');
        if (!priceEl || !produto.variants || !produto.variants.length) return;

        var disponiveis = produto.variants.filter(function (v) { return v.available; });
        var lista = (disponiveis.length ? disponiveis : produto.variants).map(function (v) { return v.price; });
        var min = Math.min.apply(null, lista);
        var temFaixa = new Set(lista).size > 1;

        priceEl.textContent = (temFaixa ? 'a partir de ' : '') + formatBRL(min);
        card.setAttribute('data-price-live', 'true');
      })
      .catch(function () {
        /* mantem o preco estatico que ja estava no card */
      });
  }

  function iniciar() {
    document.querySelectorAll('.dv-body-wrap .produto-card[href*="/products/"]').forEach(atualizarCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
